import { Stack } from '@mui/material'
import { FormProps } from '@storage/app/models'
import { ControlledTextField } from '@storage/components/form-controls'
import { WeightClassContainerUIStore } from '@storage/features/weight-classes/stores/weight-class-container-ui-store'
import { ManualInputValidationStore } from '@storage/pages/container-turnovers/stores/manual-input-validation.store'
import { CompanyStore } from '@storage/stores/company.store'
import { UtilityMappers } from '@storage/utils/mappers'
import { useTranslate } from '@tolgee/react'
import { useEffect, useState } from 'react'
import { useWatch } from 'react-hook-form'
import { AllocationRuleCommonFields } from '../../components/AllocationRuleCommonFields'
import { AllocationRuleTemplateFormProfile } from '../allocation-rule-templates-form/allocation-rule-templates-form.profile'

interface Props extends FormProps {
  allocationRuleForm: any
  manualInputValidationStore: ManualInputValidationStore
  isATemplate?: boolean
  weightClassUIStore: WeightClassContainerUIStore
  companyStore: CompanyStore
  openWithOnlyContainerNumber?: boolean
  showCarrierTypeField?: boolean
  onSubmit: (formValues: AllocationRuleTemplateFormProfile) => Promise<void> | void
}

export const CarrierVisitAllocationRuleForm = ({
  allocationRuleForm,
  id,
  onSubmit,
  manualInputValidationStore,
  isATemplate,
  weightClassUIStore,
  companyStore,
  openWithOnlyContainerNumber,
  showCarrierTypeField,
}: Props) => {
  const { t } = useTranslate()

  const { handleSubmit, control, formState } = allocationRuleForm

  const destinationInputValue = useWatch({ control, name: 'destination' })

  const [isValidDangerousGoods, setIsValidDangerousGoods] = useState(true)
  const [isDangerousAlertMessage, setIsDangerousAlertMessage] = useState('')

  const dangerousSelected = useWatch({ control, name: 'facets.isDangerous' })

  useEffect(() => {
    if (destinationInputValue) {
      manualInputValidationStore.validate(destinationInputValue.trim().toUpperCase())
      const validateDangerousGoodsSelection = () => {
        const { isValidDangerousGoods, isDangerousAlertMessage } =
          manualInputValidationStore.validateDGLocation(
            UtilityMappers.mapOptionalFieldValueToBoolean(dangerousSelected),
            true,
          )
        setIsValidDangerousGoods(isValidDangerousGoods)
        setIsDangerousAlertMessage(isDangerousAlertMessage)
      }
      validateDangerousGoodsSelection()
    }
  }, [dangerousSelected, destinationInputValue, manualInputValidationStore])

  useEffect(() => {
    weightClassUIStore.loadWeightClasses()
  }, [weightClassUIStore])

  return (
    <Stack
      gap={1}
      id={id}
      component='form'
      noValidate
      autoComplete='off'
      onSubmit={handleSubmit(onSubmit)}
    >
      <ControlledTextField
        formState={formState}
        control={control}
        name='name'
        label={t('name', 'Name')}
        required
        dataCy='allocation-name-field'
      />

      <AllocationRuleCommonFields
        control={control}
        formState={formState}
        weightClassesOptions={weightClassUIStore.weightClassesOptions}
        companies={companyStore.companies}
        openWithOnlyContainerNumber={openWithOnlyContainerNumber}
        showCarrierTypeField={showCarrierTypeField}
      />
    </Stack>
  )
}
